import React, { Component } from "react";
import Translation from "../translation/translation";
import { Redirect } from "react-router-dom";
import $ from "jquery";
import Context from "../context/context";
import Comm from "../comm/comm";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

class Contragents extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;

        var contragents = Comm.Partners(sid);

        this.state = {
            Contragents: contragents,
            SelectedContragent: null,
            SelectedArticleName: null,
            SelectedReceiver: null,
        };

        this.NewContragent = this.NewContragent.bind(this);
        this.EditContragent = this.EditContragent.bind(this);
        this.SaveName = this.SaveName.bind(this);
        this.SaveInvoice = this.SaveInvoice.bind(this);
        this.EditArticleName = this.EditArticleName.bind(this);
        this.SaveArticleName = this.SaveArticleName.bind(this);
        this.EditReceiver = this.EditReceiver.bind(this);
        this.NewReceiver = this.NewReceiver.bind(this);
        this.SaveReceiver = this.SaveReceiver.bind(this);
        this.Back = this.Back.bind(this);
        this.Del = this.Del.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var self = this;

        return Context.HasRight("rcontragents") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("contragents")}</div>
                <div className="panel-body">
                    {this.state.SelectedContragent === null ? (
                        <div className="row">
                            <div className="col-lg-6 col-xs-12">
                                {Context.HasRight("econtragents") ? (
                                    <button className="btn btn-primary" onClick={this.NewContragent}>
                                        {Translation.Trans("newcontragent")}
                                    </button>
                                ) : null}

                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{Translation.Trans("name")}</th>
                                        </tr>
                                    </thead>
                                </table>
                                <div className="scrollableDiv">
                                    <table className="table table-striped">
                                        <tbody>
                                            {this.state.Contragents.map((obj) =>
                                                obj.visible ? (
                                                    <tr>
                                                        <td>
                                                            <span
                                                                className={
                                                                    this.state.SelectedContragent != null &&
                                                                        this.state.SelectedContragent.id ===
                                                                        obj.id
                                                                        ? "btn btn-warning"
                                                                        : null
                                                                }
                                                            >
                                                                <a
                                                                    onClick={() => this.EditContragent(obj)}
                                                                    className="pointhand"
                                                                >
                                                                    {obj.name}
                                                                </a>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ) : null
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {this.state.SelectedContragent !== null ? (
                        <div className="row">
                            <div className="col-lg-1">
                                <button className="btn btn-primary pull-right" onClick={this.Back}>
                                    {Translation.Trans("cancel")}
                                </button>
                                <button className="btn btn-info pull-right" onClick={() => this.Del()}>
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>

                            <div className="col-lg-5 col-xs-11">
                                <div className="row">
                                    <div className="col-lg-3">{Translation.Trans("name")}</div>
                                    <div className="col-lg-9">
                                        <input
                                            type="text"
                                            id="tbName"
                                            className="form-control"
                                            defaultValue={this.state.SelectedContragent.name}
                                            key={"name" + this.state.SelectedContragent.id}
                                        />
                                        {this.state.showMissingNameError ? (
                                            <div className="alert alert-danger">
                                                {Translation.Trans("entervalue")}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3">{Translation.Trans("nullpartner")}</div>
                                    <div className="col-lg-9">
                                        <input
                                            type="checkbox"
                                            className="form-control"
                                            checked={this.state.SelectedContragent.null_partner}
                                            key={"nullpartner" + this.state.SelectedContragent.id}
                                            onChange={(e) => {
                                                var c = self.state.SelectedContragent;
                                                c.null_partner = e.target.checked;
                                                self.setState({ SelectedContragent: c });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        {Context.HasRight("econtragents") ? (
                                            <button
                                                className="btn btn-primary pull-right"
                                                onClick={this.SaveName}
                                            >
                                                {Translation.Trans("save")}
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <b>
                                            {Translation.Trans("extendeddatafor") +
                                                " " +
                                                this.state.SelectedContragent.name}
                                        </b>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">{Translation.Trans("invoicename")}</div>
                                    <div className="col-lg-8">
                                        <input
                                            type="text"
                                            id="tbInvoiceName"
                                            className="form-control"
                                            defaultValue={this.state.SelectedContragent.invoice_name}
                                            key={"invoice_name" + this.state.SelectedContragent.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">{Translation.Trans("invoicecountry")}</div>
                                    <div className="col-lg-8">
                                        <input
                                            type="text"
                                            id="tbInvoiceCountry"
                                            className="form-control"
                                            defaultValue={this.state.SelectedContragent.invoice_country}
                                            key={"invoice_country" + this.state.SelectedContragent.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">{Translation.Trans("invoiceaddress1")}</div>
                                    <div className="col-lg-8">
                                        <textarea
                                            id="tbInvoiceAddress1"
                                            className="form-control"
                                            defaultValue={this.state.SelectedContragent.invoice_addr_line_1}
                                            key={"invoice_addr_line_1" + this.state.SelectedContragent.id}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">{Translation.Trans("invoiceaddress2")}</div>
                                    <div className="col-lg-8">
                                        <input
                                            type="text"
                                            id="tbInvoiceAddress2"
                                            className="form-control"
                                            defaultValue={this.state.SelectedContragent.invoice_addr_line_2}
                                            key={"invoice_addr_line_2" + this.state.SelectedContragent.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        {this.state.SelectedContragent.id &&
                                            Context.HasRight("econtragents") ? (
                                            <button
                                                className="btn btn-primary pull-right"
                                                onClick={this.SaveInvoice}
                                            >
                                                {Translation.Trans("save")}
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            {this.state.SelectedArticleName === null ? (
                                <div className="col-lg-6 col-xs-12">
                                    <b>
                                        {Translation.Trans("articlenamesfor") +
                                            " " +
                                            this.state.SelectedContragent.name}
                                    </b>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th width="50%">{Translation.Trans("originalname")}</th>
                                                <th width="50%">{Translation.Trans("clientname")}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div className="scrollableDiv">
                                        <table className="table table-striped">
                                            <tbody>
                                                {this.state.ArticleNames.map((obj) => (
                                                    <tr>
                                                        <td width="50%">
                                                            {this.state.SelectedContragent.id ? (
                                                                <a
                                                                    onClick={() => this.EditArticleName(obj)}
                                                                    className="pointhand"
                                                                >
                                                                    {obj.name}
                                                                </a>
                                                            ) : (
                                                                <span>{obj.name}</span>
                                                            )}
                                                        </td>
                                                        <td width="50%">{obj.name_for_partner}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div className="col-lg-6 col-xs-12">
                                    {this.state.SelectedArticleName.name}
                                    <br />
                                    <input
                                        type="text"
                                        id="tbNameForPartner"
                                        className="form-control"
                                        defaultValue={this.state.SelectedArticleName.name_for_partner}
                                        key={"name" + this.state.SelectedContragent.id}
                                    />
                                    <br />
                                    {Context.HasRight("econtragents") ? (
                                        <button
                                            className="btn btn-primary pull-right"
                                            onClick={this.SaveArticleName}
                                        >
                                            {Translation.Trans("save")}
                                        </button>
                                    ) : null}
                                </div>
                            )}
                            {this.state.SelectedReceiver === null ? (
                                <div className="col-lg-12 col-xs-12">
                                    <b>{Translation.Trans("receivers")}</b>
                                    <br />
                                    {this.state.SelectedContragent.id && Context.HasRight("econtragents") ? (
                                        <button className="btn btn-primary" onClick={this.NewReceiver}>
                                            {Translation.Trans("newreceiver")}
                                        </button>
                                    ) : null}

                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th width="50%">{Translation.Trans("name")}</th>
                                                <th width="50%">{Translation.Trans("comment")}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div className="scrollableDiv">
                                        <table className="table table-striped">
                                            <tbody>
                                                {this.state.Receivers.map((obj) => (
                                                    <tr>
                                                        <td width="50%">
                                                            <a
                                                                onClick={() => this.EditReceiver(obj)}
                                                                className="pointhand"
                                                            >
                                                                {obj.name}
                                                            </a>
                                                        </td>
                                                        <td width="50%">{obj.comment}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div className="col-lg-12 col-xs-12">
                                    <div className="row">
                                        <div className="col-lg-4">{Translation.Trans("comment")}</div>
                                        <div className="col-lg-8">
                                            <input
                                                type="text"
                                                id="tbReceiverComment"
                                                className="form-control"
                                                defaultValue={this.state.SelectedReceiver.comment}
                                                key={"tbReceiverComment" + this.state.SelectedContragent.id}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">{Translation.Trans("invoicename")}</div>
                                        <div className="col-lg-8">
                                            <input
                                                type="text"
                                                id="tbReceiverName"
                                                className="form-control"
                                                defaultValue={this.state.SelectedReceiver.name}
                                                key={"tbReceiverName" + this.state.SelectedContragent.id}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">{Translation.Trans("invoicecountry")}</div>
                                        <div className="col-lg-8">
                                            <input
                                                type="text"
                                                id="tbReceiverCountry"
                                                className="form-control"
                                                defaultValue={this.state.SelectedReceiver.country}
                                                key={"tbReceiverCountry" + this.state.SelectedContragent.id}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">{Translation.Trans("invoiceaddress1")}</div>
                                        <div className="col-lg-8">
                                            <textarea
                                                id="tbReceiverAddress1"
                                                className="form-control"
                                                defaultValue={this.state.SelectedReceiver.addr_line_1}
                                                key={"tbReceiverAddress1" + this.state.SelectedContragent.id}
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">{Translation.Trans("invoiceaddress2")}</div>
                                        <div className="col-lg-8">
                                            <input
                                                type="text"
                                                id="tbReceiverAddress2"
                                                className="form-control"
                                                defaultValue={this.state.SelectedReceiver.addr_line_2}
                                                key={"tbReceiverAddress2" + this.state.SelectedContragent.id}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            {Context.HasRight("econtragents") ? (
                                                <button
                                                    className="btn btn-primary pull-right"
                                                    onClick={this.SaveReceiver}
                                                >
                                                    {Translation.Trans("save")}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : null}
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }

    EditContragent(contragent) {
        var sid = Context.GetContext().Sid;
        var aNames = Comm.ArticleNames({
            session: sid,
            partner: contragent.id,
        });

        var receivers = Comm.Receivers({
            session: sid,
            partner: contragent.id,
        });
        this.setState({
            SelectedContragent: contragent,
            ArticleNames: aNames,
            Receivers: receivers,
        });
    }

    NewContragent() {
        var sid = Context.GetContext().Sid;
        var aNames = Comm.ArticleNames({
            session: sid,
            partner: -1,
        });

        this.setState({
            SelectedContragent: {},
            ArticleNames: aNames,
            Receivers: [],
        });
    }

    SaveName() {
        this.setState({ showMissingNameError: false });
        var canSave = true;
        var name = $("#tbName").val();

        if (name === "") {
            this.setState({ showMissingNameError: true });
            canSave = false;
        }

        if (!canSave) return;

        var contr = Object.assign({}, this.state.SelectedContragent);
        contr.name = name;

        var data = {};

        var sid = Context.GetContext().Sid;
        data.session = sid;
        data.partners = JSON.stringify([contr]);

        contr.id = Comm.SavePartner(data);
        var contragents = Comm.Partners(sid);
        this.setState({ SelectedContragent: contr, Contragents: contragents });
    }

    SaveInvoice() {
        var contr = Object.assign({}, this.state.SelectedContragent);

        contr.invoice_name = $("#tbInvoiceName").val();
        contr.invoice_country = $("#tbInvoiceCountry").val();
        contr.invoice_addr_line_1 = $("#tbInvoiceAddress1").val();
        contr.invoice_addr_line_2 = $("#tbInvoiceAddress2").val();

        var data = {};

        var sid = Context.GetContext().Sid;
        data.session = sid;
        data.partners = JSON.stringify([contr]);

        Comm.SavePartner(data);
    }

    EditArticleName(articleName) {
        this.setState({ SelectedArticleName: articleName });
    }

    SaveArticleName() {
        var data = {};

        var sid = Context.GetContext().Sid;
        data.session = sid;
        data.partner = this.state.SelectedContragent.id;
        data.name = $("#tbNameForPartner").val();
        data.article = this.state.SelectedArticleName.id;
        Comm.SaveArticleName(data);

        var aNames = Comm.ArticleNames({
            session: sid,
            partner: this.state.SelectedContragent.id,
        });
        this.setState({
            ArticleNames: aNames,
            SelectedArticleName: null,
        });
    }

    EditReceiver(receiver) {
        this.setState({ SelectedReceiver: receiver });
    }

    NewReceiver() {
        this.setState({ SelectedReceiver: {} });
    }

    SaveReceiver() {
        var rec = Object.assign({}, this.state.SelectedReceiver);

        rec.comment = $("#tbReceiverComment").val();

        rec.name = $("#tbReceiverName").val();
        rec.country = $("#tbReceiverCountry").val();
        rec.addr_line_1 = $("#tbReceiverAddress1").val();
        rec.addr_line_2 = $("#tbReceiverAddress2").val();
        rec.position = this.state.Contragents.length + 1;

        var data = {};

        var sid = Context.GetContext().Sid;
        data.session = sid;
        data.partner = this.state.SelectedContragent.id;
        data.details = JSON.stringify([rec]);

        Comm.SaveReceiver(data);

        var receivers = Comm.Receivers({
            session: sid,
            partner: this.state.SelectedContragent.id,
        });
        this.setState({
            Receivers: receivers,
            SelectedReceiver: null,
        });
    }

    Back() {
        this.setState({
            SelectedContragent: null,
            SelectedArticleName: null,
            SelectedReceiver: null,
        });
    }
    Del() {
        if (window.confirm(Translation.Trans("pleaseconfirm"))) {
            var data = this.state.SelectedContragent;
            var sid = Context.GetContext().Sid;
            data.session = sid;
            data.visible = false;
            Comm.SavePartner(data);
            this.setState({ SelectedContragent: null });
        }

        //павката не ми го е дал
    }
}

export default Contragents;



// WEBPACK FOOTER //
// ./src/pages/contragents.js